import React from 'react';
import {
    IconButton,
    ListItem,
    ListItemText,
    Checkbox,
    Tooltip,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { cylinderLabelStyle } from '../MoveCylinders/utils';
import { trakrefBlue } from '../../../color_utils';
import { isMobile } from '../../../utils.js'


const CylinderRow = ({
    locationId,
    name,
    setChecked,
    setCylinderDetails,
    cylinderId,
    cylinderIdsToMove,
    cylinder,
    selectedCylinderId,
    closeCylinderDetails,
}) => (
    <ListItem
        sx={{ ...(isMobile && {
            '& .MuiListItemSecondaryAction-root': { right: 0 }
        })}}
        secondaryAction={
            <>
                <Tooltip
                    title={selectedCylinderId === cylinderId ? "Hide Cylinder Details" : "View Cylinder Details"}
                >
                    <IconButton
                        edge="end"
                        aria-label="view"
                        onClick={() => {
                            if (selectedCylinderId === cylinderId) {
                                return closeCylinderDetails();
                            }
                            return setCylinderDetails(locationId, cylinderId);
                        }}
                    >
                        {selectedCylinderId === cylinderId ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                </Tooltip>
                <Checkbox
                    checked={cylinderIdsToMove.includes(cylinderId)}
                    onChange={e => setChecked(e.target.checked, cylinderId, cylinder)}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{ '&.Mui-checked': { color: trakrefBlue } }}
                />
            </>
        }
    >
        <ListItemText
            primary={name}
            sx={cylinderLabelStyle}
            primaryTypographyProps={{ marginRight: 5, style: { wordWrap: 'break-word' } }}
        />
    </ListItem>
);

export default CylinderRow;
